<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="550px"
    @keydown.esc="close()"
  >
    <v-card>
      <v-card-title> </v-card-title>

      <v-card-text>
        <label class="file-select">
          <div
            class="select-button mb-1"
            style="font-size: 1.1em; background-color: #eb74a9"
          >
            <span v-if="file"> File da importare : {{ file.name }} </span>
            <span v-else> Seleziona File ...</span>
          </div>
          <input type="file" :accept="fileFilter" @input="handleFileChange" />
        </label>
        <div>
          <v-alert
            :value="!alertElaborazione"
            type="info"
            outlined
            color="#44433e"
          >
            {{ alert }}
          </v-alert>
          <v-alert
            :value="!!alertElaborazione"
            :type="type"
            transition="scale-transition"
          >
            {{ alertElaborazione }}
          </v-alert>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="44433e" :disabled="loading" text @click.native="close()">
          Annulla
        </v-btn>

        <v-btn
          :loading="loading"
          :disabled="loading"
          text
          color="44433e"
          @click.native="conferma"
        >
          Importa
          <v-icon right dark>cloud_upload</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { upload_fileAnagrafica } from "@/api/api.agenti.js";

export default {
  props: {
    dialog: { type: Boolean, default: false },
    alert: { type: String, default: "" },
    fileFilter: { type: String, default: "" },
    pagina: { type: String, default: "" },
  },

  data: () => ({
    file: "",
    loading: false,
    alertElaborazione: "",
    type: "success",
  }),

  methods: {
    async conferma() {
      // Controllo presenza file
      if (this.file.length == 0) return;

      this.loading = true;

      let formData = new FormData();
      formData.append("file", this.file);
      let res = null;
      if (this.pagina == "agenti") res = await upload_fileAnagrafica(formData);
      else return;

      if (res.data == "OK") {
        this.alertElaborazione =
          "Elaborazione completata: file caricato con successo";
        this.type = "success";
      } else {
        this.alertElaborazione = "Errore: " + res.data;
        this.type = "error";
      }
      this.loading = false;
    },

    close() {
      this.file = "";
      this.alertElaborazione = "";

      this.$emit("chiudiDialogFile");
    },

    handleFileChange(e) {
      this.file = e.target.files[0];
    },
  },
};
</script>


<style scoped>
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #2196f3;

  border-radius: 0.3rem;

  text-align: center;
  font-weight: bold;
  cursor: pointer;
}

.file-select > input[type="file"] {
  display: none;
}
</style>
